import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { PUT } from '../consts/Methods';
import { ACCEPT_BUY_NOW_CONTRACT, ACCEPT_BUY_NOW_CONTRACT_FAIL,
         ACCEPT_BUY_NOW_CONTRACT_SUCCESS } from '../redux/OffersDetails';

function* acceptBuyNowContractFlow({ payload: { buyNowId, }, }) {
  try {
    const endpoint = `${apiRoot}/buy_now_contracts/${buyNowId}/accept`;
    const response = yield call(apiCall, { method: PUT, endpoint, });
    yield put(ACCEPT_BUY_NOW_CONTRACT_SUCCESS(response));
  } catch (error) {
    yield put(ACCEPT_BUY_NOW_CONTRACT_FAIL(error));
  }
}

export default function* AcceptBuyNowContract() {
  yield takeLatest(ACCEPT_BUY_NOW_CONTRACT, acceptBuyNowContractFlow);
}
